import { ModalProps } from "./Modal";
import Message from "./Message";
import { formatCurrency } from "../../utils";
import { useTranslation, useAppDispatch, useAppSelector } from "../../hooks";
import { setPreviousWin } from "../../store/slices/previous-win";

const PreviousWin: React.FC<ModalProps> = ({ shown }) => {
  const dispatch = useAppDispatch();
  const { currency, value } = useAppSelector((state) => {
    return { currency: state.details.currency, value: state.previousWin };
  });
  const onHideEnd = () => dispatch(setPreviousWin(0));

  return (
    <Message
      shown={shown && value > 0}
      icon="Info"
      title={useTranslation("lastspin")}
      message={useTranslation("previouswin", formatCurrency(value, currency))}
      onHideEnd={onHideEnd}
    />
  );
};

export default PreviousWin;
